import axios from 'axios';
import { Helpers } from '../helpers/Helpers';

/**
 * Çalışma Saatleri (İnsan Kaynakları > Tanımlamalar, 11.10.2026).
 * İşletme için bir kez girilir, tüm personele uygulanır. Saatler "HH:mm".
 */

export interface CalismaGunu {
    calisir: boolean
    baslangic: string | null
    bitis: string | null
    araBaslangic: string | null
    araBitis: string | null
    /**
     * Mesai hatırlatma (#504): başlangıçtan önce / bitişten sonra ilk bildirimin dakikası; boş = bildirim yok.
     * Hatırlatma: tekrar aralığı (dk); boş = yalnız ilk bildirim. En fazla 3 bildirim.
     */
    bildirimDk?: number | null
    hatirlatmaDk?: number | null
}

/**
 * Mola (çay molası vb., 12.10.2026). İşaretli günlerde normal mesaiden düşülür (kişi o saatte içerideyse); ek mesaiyi etkilemez.
 * Liste çalışma saatleriyle birlikte kaydedilir (Kaydet listeyi tümüyle yeniler).
 */
export interface CalismaMolasi {
    calismaMolasiId?: string | null
    ad: string
    baslangic: string
    bitis: string
    pazartesiPersembe: boolean
    cuma: boolean
    cumartesi: boolean
    pazar: boolean
}

export interface CalismaSaati {
    /** Pazartesi–Perşembe. */
    haftaIci: CalismaGunu
    /** Cuma: hafta içi çarpanı kullanılır. */
    cuma: CalismaGunu
    cumartesi: CalismaGunu
    pazar: CalismaGunu
    carpanHaftaIci: number
    carpanCumartesi: number
    carpanPazar: number
    carpanResmiTatil: number | null
    /** Saatlik ücret böleni: saatlik ücret = aylık maaş ÷ bölen (varsayılan 200). */
    saatlikBolen: number
    molalar: CalismaMolasi[]
    /**
     * Ek mesai talebinde seçilen saat aralıkları (QR Mesai Faz 2, 18.10.2026): her biri "HH:mm-HH:mm", en az bir.
     * Eski sunucu göndermezse ekran varsayılan üç aralığı önerir.
     */
    talepAraliklari?: string[] | null
    updatedDate?: string | null
    updatedUser?: string | null
}

interface Yanit<T> { isSuccess: boolean, message?: string, data: T }

const cagir = async <T>(uc: string, govde: any = {}): Promise<Yanit<T>> => {
    try {
        console.log('SERVICE CALL - CalismaSaati/' + uc, JSON.stringify(govde));
        const resp = await axios.post(Helpers.getEndpoint() + '/CalismaSaati/' + uc, govde);
        return Helpers.dataParser(resp);
    } catch (error) {
        throw Helpers.parseErrorMessage(error);
    }
}

export class CalismaSaatiService {
    static getir = () => cagir<CalismaSaati>('Getir');
    static kaydet = (istek: CalismaSaati) => cagir<CalismaSaati>('Kaydet', istek);
}
